import { all } from "redux-saga/effects";
import { appNoticeSaga } from "./appNoticeSaga";
import { watchDashboard } from "./dashboardSaga";
import { disabledUsersSaga } from "./disabledUsersSaga";
import { doctorAdminSaga } from "./doctorAdminSaga";
import { doctorInvitationSaga } from "./doctorInvitationSaga";
import { facilitySaga } from "./facilitySaga";
import { faqSaga } from "./faqSaga";
import { featureFlagSaga } from "./featureFlagSaga";
import { managerSaga } from "./managerSaga";
import { notificationSaga } from "./notificationSaga";
import { watchSession } from "./sessionHandler";
import { specialtySaga } from "./specialtySaga";
import { staticDoctorProfileSaga } from "./staticDoctorProfileSaga";
import { unverifiedUsersSaga } from "./unverifiedUsersSaga";

export function* rootSaga() {
  yield all([
    watchSession(),
    watchDashboard(),
    managerSaga(),
    facilitySaga(),
    faqSaga(),
    specialtySaga(),
    disabledUsersSaga(),
    unverifiedUsersSaga(),
    doctorInvitationSaga(),
    doctorAdminSaga(),
    staticDoctorProfileSaga(),
    appNoticeSaga(),
    featureFlagSaga(),
    notificationSaga(),
  ]);
}
